import * as React from 'react';
export const baseSvg = React.forwardRef(function baseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0052FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M15.98 28C22.617 28 28 22.628 28 16c0-6.627-5.382-12-12.02-12C9.68 4 4.512 8.836 4 14.992h15.889v2.017H4C4.513 23.164 9.68 28 15.98 28Z',
    }),
  );
});
baseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var base = {
  category: 'brand',
  colorable: false,
  name: 'base',
  svg: baseSvg,
};
